import { get } from '@/lib/api';
import type { Dashboard } from './types';

/**
 * One request for the whole screen.
 *
 * Deliberately not eight — the dashboard is the first thing after login, and
 * eight parallel requests on a shop's connection is the difference between
 * "fast" and "it hangs". The server caches the response for 60 seconds
 * (docs/security-and-scale.md); it is a summary, not a ledger.
 */
export function fetchDashboard(params: { days?: number; outlet_id?: number | 'all' }) {
  return get<Dashboard>('/dashboard', params);
}
